import Environments from '@delta-defense/client-environments';
import { Apis } from '@delta-defense/client-environments/environments/enums/apis';
import { APIData, ApiResult } from '@delta-defense/delta-development-kit/apiResult';
import { IRest, Rest } from '../rest/rest';

type ResumeRegistrationData = APIData<{
	eventId: number;
	token: string;
	url: string;
}>;

export interface IEvents {
	getResumeUrl(eventId: string, accessToken: string): Promise<ApiResult<ResumeRegistrationData>>;
}

export class Events implements IEvents {
	private static instance: IEvents | null = null;
	public static Instance(
		eventsProxyDomain: string = Environments.getProxyEndpointForApi(Apis.Events),
		rest = Rest.Instance()
	): IEvents {
		return this.instance || (this.instance = new Events(eventsProxyDomain, rest));
	}
	public static Destroy = () => (Events.instance = null);

	private constructor(
		private productsProxyDomain: string,
		public rest: IRest
	) {}

	public getResumeUrl = async (eventId: string, accessToken: string) => {
		const response = await this.rest.Get<ResumeRegistrationData>(
			`${this.productsProxyDomain}/events/${eventId}/registration/resume`,
			{ 'X-Auth-Token': accessToken }
		);
		return {
			wasSuccessful: response.ok,
			value: response.body,
			status: response.status,
			statusText: response.statusText
		};
	};
}
